import { Link } from "gatsby";
import * as React from "react";
import Arrow from "../../images/ico_arrow_white.svg";

export const Breadcrumbs = ({
    links,
    stopTreeAfter
}: {
    links: { path?: string; text: string }[];
    stopTreeAfter?: number;
}) => {
    let mobileLink;
    for (let i = links.length - 2; i >= 0; i--) {
        const link = links[i];
        if (link.path) {
            mobileLink = link;
            break;
        }
    }
    if (!mobileLink) {
        mobileLink = links[0];
    }
    return (
        <>
            <p className="absolute top-[12px] left-[16px] text-white/90 md:hidden">
                <MobileLink path={mobileLink.path} text={mobileLink.text} />
            </p>
            <ul className="absolute top-[24px] left-[40px] inline-flex text-white mdmax:hidden">
                {links.map((link, i) => (
                    <DesktopLink
                        key={link.path}
                        path={link.path}
                        text={link.text}
                        noTree={stopTreeAfter && i >= stopTreeAfter}
                        last={i === links.length - 1}
                    />
                ))}
            </ul>
        </>
    );
};

const DesktopLink = ({ path, text, noTree, last }) => {
    return (
        <li
            className={
                noTree
                    ? `text-white/70 ${
                          !last &&
                          "after:w-[6px] after:pr-2 after:content-[',']"
                      }`
                    : `${
                          !last
                              ? "text-white/70 after:w-7 after:px-3 after:content-['/']"
                              : "text-white/95"
                      }`
            }
        >
            {path ? (
                <Link className="text-sm font-medium tracking-wider" to={path}>
                    {text}
                </Link>
            ) : (
                <>{text}</>
            )}
        </li>
    );
};

const MobileLink = ({ path, text }) => {
    return (
        <>
            {path ? (
                <Link
                    to={path}
                    className="inline-flex items-baseline text-sm font-medium tracking-wide underline"
                >
                    <img
                        alt=""
                        src={Arrow}
                        className="relative bottom-[1px] mr-2 rotate-90"
                    />
                    <span>{text}</span>
                </Link>
            ) : (
                <>
                    <img
                        alt=""
                        src={Arrow}
                        className="relative bottom-[1px] mr-2 rotate-90"
                    />
                    <span>{text}</span>
                </>
            )}
        </>
    );
};
